import {
  LOG_IN,
  SET_DISPLAY,
  INIT_DATABASE,

  SET_FOCUSED_ISLAND
} from './';

export function logIn(username, password) {
  console.log(username, password)
  return{
    type: LOG_IN,
    username,
    password
  };
};

export function setDisplayIslandBlock(blockName, bool) {
  console.log('set display as', bool, 'on', blockName);
  return {
    type: SET_DISPLAY,
    blockName,
    bool
  };
};

export function initDatabase(obj) {
  console.log('redux obj :', obj)
  return {type: INIT_DATABASE, database: obj};
}

export function setFocusedIsland(island) {
  return { type: SET_FOCUSED_ISLAND, focusedIsland: island }
}